<div class="discount-label d-flex justify-content-center align-items-center">
  <span class="badge" data-e2e="discount">{{ discountLabel }}</span>
</div>
